module.exports = __webpack_public_path__ + "assets/img/stock.5d15a1ea.svg";